import { useState } from 'react'
import { addCalendarYears } from '@deepguide-ai/shared'
import { DatePicker } from '@deepguide-ai/ui/date-picker'
import { Label } from '@deepguide-ai/ui/label'
import {
  dateInputValueToDate,
  dateToDateInputValue,
} from '@/lib/date-picker-value'

export function useExceptionExpiry(expiresAt?: string | null) {
  const initialValue = expiresAt
    ? dateToDateInputValue(new Date(expiresAt))
    : dateToDateInputValue(addCalendarYears(new Date(), 1))
  const [value, setValue] = useState(initialValue)

  return {
    value,
    setValue,
    reset: () => setValue(initialValue),
    expiresAt: dateInputValueToDate(value)?.toISOString() ?? null,
  }
}

export function ExceptionExpiryField({
  value,
  onChange,
}: {
  value: string
  onChange: (value: string) => void
}) {
  return (
    <div className='space-y-1.5'>
      <Label className='font-body text-text-body text-[11px]'>Expires</Label>
      <DatePicker
        value={dateInputValueToDate(value)}
        onChange={(date) => onChange(dateToDateInputValue(date))}
        className='font-body border-border-divider text-text-secondary h-8 w-full rounded-sm border bg-card px-2 text-[12px] outline-none focus:border-ring'
      />
      <div className='font-body text-text-subtle text-[10px]'>
        Defaults to one year from today.
      </div>
    </div>
  )
}
